import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
  { key: 'stairs', label: <FormattedMessage id="hosting.access_types.stairs" defaultMessage="Stairs" /> },
  { key: 'elevator', label: <FormattedMessage id="hosting.access_types.elevator" defaultMessage="Elevator" /> },
  { key: 'ground_floor', label: <FormattedMessage id="hosting.access_types.ground_floor" defaultMessage="Ground Floor" /> },
  { key: 'freight_elevator', label: <FormattedMessage id="hosting.access_types.freight_elevator" defaultMessage="Freight Elevator" /> }
];
